import React from 'react';
import styles from '../InviteTeamMember.module.css';
import TwoColumnContent from '../../../components/TwoColumnContent/TwoColumnContent';
import LeftColumn from '../../../components/TwoColumnContent/LeftColumn/LeftColumn';
import TitleDescription from '../../../components/TitleDescription/TitleDescription';
import RightColumn from '../../../components/TwoColumnContent/RightColumn/RightColumn';
import { AdminSelect } from '@project/components';
import { USER_TITLES as titleOptions } from '../../../constants';
import { useIntl } from 'react-intl';
import { useFormContext } from 'react-hook-form';

export const TeamMemberCompanyTitle = (props) => {

  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  const form = useFormContext();

  return (
    <TwoColumnContent bottomBorder={true}>
      <LeftColumn>
        <TitleDescription
          title={t('InviteTeamMember.companyTitle.title')}
          description={t('InviteTeamMember.companyTitle.details')} />
      </LeftColumn>
      <RightColumn >
        <AdminSelect
          id="companyTitle"
          propStyles={styles.adminSelect}
          label={t('InviteTeamMember.companyTitle.label')}
          defaultValue=""
          placeholder={t('InviteTeamMember.companyTitle.placeholder')}
          options={titleOptions}
          value={form.watch('companyTitle')}
          onChange={(c) => form.setValue('companyTitle', c)}
          isLoading={false} />
      </RightColumn>
    </TwoColumnContent>
  )
}